import { lazy } from 'react'

import { useParams } from 'react-router'

import { Page } from '@webapp/core/components/Page'
import { useAppRoutes, useProcurifyIntl } from '@webapp/hooks'
import { useLegalEntityDetailsPage } from '@webapp/platform/legal-entities/pages/hooks/useLegalEntityDetailsPage'
import messages from './messages'
import {
  type LegalEntityDetailsPageParams,
  LegalEntityListPageTabTypes,
} from './types'

const LegalEntityDetailsFeatureSetChunk = lazy(() =>
  import('../feature-sets/LegalEntityDetailsFeatureSet').then(
    ({ LegalEntityDetailsFeatureSet }) => ({
      default: LegalEntityDetailsFeatureSet,
    })
  )
)

export const LegalEntityDetailsPage = () => {
  const intl = useProcurifyIntl()
  const { url } = useAppRoutes()
  const { uuid } = useParams<LegalEntityDetailsPageParams>()

  const {
    data: { entity },
  } = useLegalEntityDetailsPage({ uuid })

  // Return the user to the tab the entity belongs to (falls back to Active
  // while the entity is still loading).
  const listTab =
    entity?.active === false
      ? LegalEntityListPageTabTypes.INACTIVE
      : LegalEntityListPageTabTypes.ACTIVE

  return (
    <Page
      pageTitle={intl.formatMessage(messages.manageEntitiesTitle)}
      breadcrumbs={[
        {
          link: url('SettingsPage'),
          name: intl.formatMessage(messages.settingsTitle),
        },
        {
          link: url('LegalEntityListPage', { tab: listTab }),
          name: intl.formatMessage(messages.manageEntitiesTitle),
        },
        {
          name: entity?.name ?? '',
          escapeCaseFormatting: true,
        },
      ]}
    >
      <LegalEntityDetailsFeatureSetChunk />
    </Page>
  )
}
